import { NavigateOrNotifyParent } from '@/types/navigation.typs';

const DEFAULT_MIN_LENGTH = 2;

/**
 * If value meets min length, calls onNavigate(value). Otherwise, when in iframe,
 * sends { type: eventType, ...payload } to parent.
 * Reusable from SearchStart, PLP, or any page that needs "navigate or notify parent" behavior.
 */
export function navigateOrNotifyParent({
  value,
  eventType,
  payload,
  onNavigate,
  postMessageToParent,
  isInIframe,
  minLength = DEFAULT_MIN_LENGTH,
}: NavigateOrNotifyParent): void {
  if (value.trim().length >= minLength) {
    onNavigate(value);
    return;
  }
  if (isInIframe) {
    postMessageToParent({ type: eventType, ...payload }, '*');
  }
}
